<template>
  <!-- 新建维修站 -->
  <div class="register-page ">
    <!-- <div class="content">
      <van-form @submit="onSubmit" :show-error="false">
        <van-field v-model="kongzTokenDTO.consumerName" name="维修站名称" label="维修站名称" placeholder="点击填写维修站名称"
          :rules="[{ required: true, message: '请输入维修站名称' }]" :disabled="Boolean(kongzTokenDTO.consumerName)" />
        <van-field v-model="detailAddress" name="维修站地址" label="维修站地址" placeholder="点击填写维修站地址"
          @focus="$refs.popupAddress.open()" readonly />
        <van-field v-model="name" name="姓名" label="姓名" placeholder="点击填写姓名"
          :rules="[{ required: true, message: '请输入姓名' }]"  />
        <van-field v-model="password" name="password" label="密码" placeholder="点击设置密码" type="password" v-if="!clientUser"
          :rules="[{ required: true, message: '请输入密码' }]" />
        <van-field v-model="confirmPassword" name="confirmPassword" label="确认密码" placeholder="点击确认密码" :rules="[{ required: true, message: '请输入确认密码' },
        { validator: validatorPassword, message: '密码不一致' }]" type="password" v-if="!clientUser" />
        <van-field v-model="phone" name="维修站手机号" label="维修站手机号" placeholder="点击填写手机号"
          :rules="[{ required: true, message: '请输入手机号' }]" disabled>
          <template #button>
            <div @click="getCode(phone)">
              <countdownButton ref="countDown"></countdownButton>
            </div>
          </template>
        </van-field>
        <van-field v-model="verifyCode" name="验证码" label="验证码" placeholder="点击填写验证码"
          :rules="[{ required: true, message: '请输入验证码' }]" />
        <div class="confirmButton">
           <van-button  block type="primary" native-type="submit">确认{{ fixedButtonText }}
          </van-button>
        </div>
      </van-form>
      <PopupAddress ref="popupAddress" @setLocation="setLocation"></PopupAddress>
    </div> -->
  </div>
</template>

<script>
// import countdownButton from './countdown-button.vue'
// import PopupAddress from '../../../center/component/popup-address.vue'
import { kangzhongApi } from '@/api/bind'
// import { cryptoUtils } from '@/utils/common'
export default {
  components: {
    // countdownButton,
    // PopupAddress
  },
  props: {
    clientInfo: {
      type: Object,
      default: () => { }
    },
    kongzTokenDTO: {
      type: Object,
      default: () => { }
    },
    fixedButtonText: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      verifyCode: '', // 验证码
      clientName: '',
      detailAddress: '',
      provinceName: '',
      cityName: '',
      countyName: '',
      password: '',
      confirmPassword: '',
      phone: '',
      name: '',
      clientUser: ''
    }
  },
  computed: {},
  mounted () {
    this.onSubmit()
  },
  methods: {
    // queryUser () {
    //   this.$toast.loading({
    //     duration: 0,
    //     message: '加载中...',
    //     forbidClick: true
    //   })
    //   kangzhongApi.queryUser({ userMobile: this.kongzTokenDTO.phone }).then(res => {
    //     if (res.data.resultCode === '0') {
    //       this.$toast.clear()
    //       const { clientUser } = res.data.resultData
    //       this.clientUser = clientUser || ''
    //       if (this.clientUser) {
    //         this.name = this.clientUser.userName
    //         this.phone = this.clientUser.userMobile
    //       } else {
    //         this.name = this.kongzTokenDTO.name
    //         this.phone = this.kongzTokenDTO.phone
    //       }
    //       this.onSubmit()
    //     }
    //   }).catch(() => { this.$toast.clear() })
    // },
    getCode (phone) {
      if (!this.$refs.countDown.isGeting && phone.trim()) {
        kangzhongApi.getVerifyCode({ phone: phone.trim() }).then(res => {
          if (res.data.resultCode === '0') {
            this.$toast('已发送验证码')
            this.$refs.countDown.startDown()
          }
        })
      }
    },
    onSubmit () {
      let data = {
        uuid: this.kongzTokenDTO.uuid,
        phone: this.kongzTokenDTO.phone,
        name: this.kongzTokenDTO.name,
        // verifyCode: this.verifyCode.trim(),
        clientName: this.kongzTokenDTO.consumerName,
        detailAddress: this.detailAddress,
        provinceName: this.provinceName,
        cityName: this.cityName,
        countyName: this.countyName,
        userRole: this.kongzTokenDTO.userRole,
        isCreate: '01'
      }
      // if (!this.clientUser) {
      //   data.password = cryptoUtils.AESEncrypt(this.password)
      // }
      this.$emit('submit', data)
    },
    setLocation (value) {
      this.provinceName = value[0].name
      this.cityName = value[1].name
      this.countyName = value[2].name
      this.detailAddress = value[0].name + value[1].name + value[2].name
    },
    // 验证确认密码
    validatorPassword (val) {
      return this.password === val
    }
  }
}
</script>
<style  scoped lang="less">
.register-page {
  .content {
    background-color: #fff;
  }

  .van-cell {
    background-color: #fff;

    /deep/ .van-field__label {
      width: 100%;
    }
  }
}

.bottom {
  background-color: #fff;
  padding: 0.5rem;
  box-sizing: border-box;
}

.confirmButton {
  padding: 0.5rem;
}
</style>
